var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        attrs: {
          "background-color": _vm.backgroundColor,
          outlined: _vm.outlined,
          items: _vm.items,
          "item-text": "itemName",
          "item-value": "id",
          label: _vm.$t("components.ajaxFile.label"),
          "append-icon": "cloud_upload",
          "error-messages": _vm.validationMessage,
          multiple: "",
          "menu-props": { value: false }
        },
        nativeOn: {
          focusin: function($event) {
            _vm.dialog = true
          }
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(data) {
              return [
                _c(
                  "v-chip",
                  {
                    key: JSON.stringify(data.item),
                    attrs: { small: "", selected: data.selected },
                    on: {
                      input: function($event) {
                        return data.parent.selectItem(data.item)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(data.item.itemName) + " ")]
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.items,
          callback: function($$v) {
            _vm.items = $$v
          },
          expression: "items"
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("components.ajaxFile.headline")))
                ])
              ]),
              _vm._l(_vm.items, function(item) {
                return _c(
                  "v-card-text",
                  { key: item.id },
                  [
                    _c(
                      "v-card",
                      {
                        class: {
                          "green accent-1": item.uploadedSize === item.fileSize
                        }
                      },
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-row",
                              { staticClass: "mx-0" },
                              [
                                _c("v-col", [
                                  _c("strong", [_vm._v(_vm._s(item.itemName))]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        Number.parseFloat(
                                          item.fileSize / 1000
                                        ).toFixed(1)
                                      ) +
                                      " KB) " +
                                      _vm._s(item.status) +
                                      " "
                                  )
                                ]),
                                _c("v-spacer"),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      disabled:
                                                        _vm.$store.getters[
                                                          "Ajax/loading"
                                                        ]
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downloadFile(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("cloud_download")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("global.downloadFile")) +
                                        " "
                                    )
                                  ]
                                ),
                                !_vm.readonly
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          disabled:
                                                            _vm.$store.getters[
                                                              "Ajax/loading"
                                                            ]
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeFile(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("close")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("global.removeFile")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            item.uploadedSize !== item.fileSize
                              ? _c("v-progress-linear", {
                                  attrs: {
                                    value:
                                      (item.uploadedSize / item.fileSize) * 100
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              !_vm.readonly
                ? _c(
                    "v-row",
                    { staticClass: "mx-0" },
                    [
                      _c("v-col", { staticClass: "ma-3" }, [
                        _c(
                          "form",
                          { ref: "inputForm" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary",
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.fileInput.click()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("global.choseFile")))]
                            ),
                            _vm.uploadButton
                              ? _c("input", {
                                  ref: "fileInput",
                                  staticStyle: { display: "none" },
                                  attrs: { type: "file", accept: _vm.accept },
                                  on: {
                                    change: function($event) {
                                      return _vm.upload($event)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }